$(function(){
	$('.menu-icon').on('click', function (){
		let wrapMobile = $('#header .wrap-mobile');
		let wrapMobileHeight = 0;
		let bannerNotif = $('.header_notif');
		let bannerNotifHeight = 0;
		let headerHeight = $('#header').outerHeight();
		if (bannerNotif && bannerNotif.is(':visible')) {
			bannerNotifHeight = bannerNotif.outerHeight();
			wrapMobileHeight = $(window).innerHeight() - bannerNotifHeight - 70;
		}
		if ($('#header').hasClass('scr')) {
			wrapMobile.css({'top': headerHeight + 'px'});
			wrapMobileHeight = wrapMobileHeight + bannerNotifHeight;
		} else {
			wrapMobile.css({'top': headerHeight + bannerNotifHeight + 'px'});
		}
		$('body').toggleClass('mob-menu');
		$('.menu-icon, .wrap-mobile').toggleClass('is-open');
		$('.wrap-mobile ul li a.col').removeClass('is-active');
		$('.wrap-mobile ul li a.col + div').css({'height':'0px'});
		if (wrapMobile.hasClass('is-open') && wrapMobileHeight) {
			wrapMobile.css({'height':wrapMobileHeight+'px'});
		}
		setTimeout(function (){reCalc();}, 300);
	});

	function reCalc() {
		let headerHeight = $('#header').outerHeight();
		let scr = $('#header').hasClass('scr');
		if (scr) {
			$('#header .wrap-mobile').css({'height':'calc(100dvh - ' + headerHeight + 'px)'});
		}
	}

	$('.wrap-mobile ul.menu > li > a.col').on('click', function(){
		let thisLink = $(this);
		let thisOpen = $(this).next().height();
		$('.wrap-mobile ul.menu > li > a.col').removeClass('is-active');
		$('.wrap-mobile ul.menu > li > a.col + div').css({'height':'0px'});
		if (!thisOpen) {
			thisLink.addClass('is-active');
			$(this).next().removeAttr('style').css({'height': $(this).next().find('ul').first().height() + 30 + 'px', 'overflow':'hidden'});
		}
	});

	$('.notif_close').on('click', function(){
		let wrapMobile = $('#header .wrap-mobile');
		let wrapMobileHeight = 0;
		setCookie('notifHide', 1, 7 * 24 * 60 * 60);
		$(this).parent().hide();
		if (wrapMobile.hasClass('is-open')) {
			wrapMobileHeight = $(window).height() - 70;
			wrapMobile.css({'height': wrapMobileHeight + 'px', 'top': $('#header').outerHeight() + 'px'});
		}
	});

	$('.header__account .ava__logout').on('click', function(){
		App.auth.massLogout();
	});

	$('body.mobile #header .wrap ul.menu > li > a, body.mobile #header .wrap ul.headerMenu-lang > li > .col').on('click', function(){
		$('#header .menuItem-hovered').removeClass('menuItem-hovered');
		$('#header .menuItem-open').removeClass('menuItem-open');
		$(this).parent().addClass('menuItem-hovered');
		$(this).next().find('ul').addClass('menuItem-open');
		return false;
	});

	$('body.mobile').click(function(e){
		if (!$(e.target).hasClass('col')) {
			$('#header .menuItem-open').removeClass('menuItem-open');
			$('#header .menuItem-hovered').removeClass('menuItem-hovered');
		}
	});

	$(window).on('resize scroll', function () { reCalc(); });

	$('.header__menu-bottom button.menu__lang').on('click', function(){
		$('.lang-switcher-dark').addClass('is-active'); return false;
	});

	$('.header__demo').click(function(){ try { dataLayer.push({'event':'header_contact_sales'}); } catch (e) { console.error(e, e.stack); } });
	$('.header__signup').click(function(){ try { dataLayer.push({'event':'header_signup'}); } catch (e) { console.error(e, e.stack); } });
	$('.header__login').click(function(){ try { dataLayer.push({'event':'header_login'}); } catch (e) { console.error(e, e.stack); } });
	$('.block[data-block="new_block1"] #btn__registration').click(function(){ try { dataLayer.push({'event':'hero_get_started'}); } catch (e) { console.error(e, e.stack); } });
});